<template>
    <footer class="footer position-relative">
        <div class="footer-top">
            <div class="b-container">
                <div class="row">
                    <div class="col-xl-4 footer-contact-info">
                        <h3>Contact Info</h3>

                        <div class="footer-contact">
                            <span class="icon d-flex">
                                <i class="icofont-google-map"></i>
                            </span>

                            <address
                                v-text="$root.siteConfig.site_settings.address"
                            ></address>
                        </div>
                        <div class="footer-contact">
                            <span class="icon d-flex">
                                <i class="icofont-phone"></i>
                            </span>

                            <a
                                :href="
                                    'tel:' +
                                        $root.siteConfig.site_settings.phone1
                                "
                                v-text="$root.siteConfig.site_settings.phone1"
                            ></a
                            ><br />
                            <a
                                :href="
                                    'tel:' +
                                        $root.siteConfig.site_settings.phone2
                                "
                                v-text="$root.siteConfig.site_settings.phone2"
                            ></a>
                        </div>
                        <div class="footer-contact">
                            <span class="icon d-flex">
                                <i class="icofont-envelope"></i>
                            </span>

                            <a
                                :href="
                                    'mailto:' +
                                        $root.siteConfig.site_settings
                                            .author_email
                                "
                                v-text="
                                    $root.siteConfig.site_settings.author_email
                                "
                            ></a>
                        </div>
                    </div>
                    <div class="col-xl-8">
                        <div class="row">
                            <div class="col-lg-6 footer-companies">
                                <h3>Companies</h3>
                                <ul class="d-flex flex-wrap">
                                    <li
                                        v-for="(company, index) in $root
                                            .siteConfig.companies"
                                        :key="index"
                                    >
                                        <a
                                            :href="
                                                $root.siteConfig.routes.details.replace(
                                                    'name',
                                                    company.name
                                                )
                                            "
                                            v-text="company.title"
                                        ></a>
                                    </li>
                                </ul>
                            </div>

                            <div class="col-lg-3 col-sm-6">
                                <h3>Quick Link</h3>
                                <ul class="quickLink">
                                    <li
                                        v-for="(nav, index) in quickLinks"
                                        :key="index"
                                    >
                                        <a :href="nav.link">
                                            {{ nav.title }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-3 col-sm-6 download">
                                <h3>Download</h3>

                                <a
                                    download
                                    :href="$root.siteConfig.download.link"
                                    class="brochure"
                                >
                                    <i
                                        :class="
                                            'icofont-' +
                                                $root.siteConfig.download.icon
                                        "
                                    ></i>
                                    <span
                                        v-text="$root.siteConfig.download.title"
                                    ></span>
                                </a>
                                <div class="social">
                                    <a
                                        :href="link"
                                        target="_blank"
                                        v-for="(link, index) in socials"
                                        :key="index"
                                    >
                                        <i :class="'icofont-' + index"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer-btm">
            <p>
                &copy; Copyright {{ fullYear }}
                {{ $root.siteConfig.site_settings.site_title }}
            </p>
        </div>
        <img
            class="footer-shadow img-fluid"
            :src="$root.host + '/assets/images/footer-shadow.png'"
            alt="logo"
        />
    </footer>
</template>
<script>
export default {
    data() {
        return {
            fullYear: new Date().getFullYear(),
            quickLinks: _.filter(this.$root.siteConfig.navs, function(o) {
                return o.footer == true;
            }),
            socials: this.$root.siteConfig.site_settings.social
        };
    }
};
</script>
